import camelCase from 'lodash/camelCase'

const requireModule = require.context('.', true, /^((?!router).)*\.js$/)

const modules = requireModule
  .keys()
  .filter(fileName => fileName !== './router.js' && fileName !== './store.js')
  .reduce((accumulator, fileName) => {
    const modulePath = fileName
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '')
      .split(/\//)
      .map(camelCase)
    const moduleName = modulePath.shift()
    accumulator[moduleName] = requireModule(fileName).default
    return accumulator
  }, {})

export default modules
